import { ActionIcon, Button, MultiSelect, Select, Text, Tooltip } from "@mantine/core";
import Page from "../../components/layout/Page.jsx";
import { useFetch } from "../../helpers/useFetch.js";
import { useLoaderData } from "react-router-dom";
import { parseFullName } from "../../helpers/helpers.js";
import Table from "../../components/table/core/Table.jsx";
import { useState } from "react";
import { IconCheck, IconX } from "@tabler/icons-react";
import { toast } from "react-hot-toast";
import { sortNovideo } from "../../components/table/sort.js";

export const loader = async () => {
  return useFetch(`photographer/novideo`);
};

export default function NoVideoOverview() {
  const noVideoList = useLoaderData().data;
  const [loading, setLoading] = useState(false);
  const [children, setChildren] = useState(noVideoList.children);

  const childTeam = (child) => {
    return (
      <Text span color={!child?.team && "red"}>
        {child?.team ? child.team : "Nepřidělen"}
      </Text>
    );
  };

  const columns = [
    {
      accessor: "name",
      title: "Jméno",
      render: (child) => parseFullName(child),
      sortable: true,
    },
    {
      accessor: "team",
      title: "Oddíl",
      render: (child) => childTeam(child),
      sortable: true,
    },
    {
      accessor: "room",
      title: "Pokoj",
      render: (child) => (child.room ? child.room : "-"),
      sortable: true,
    },
  ];

  const filterConfig = [
    {
      key: "jmeno",
      label: "Jméno",
      type: "search",
      function: (user, value) => {
        return parseFullName(user).toLowerCase().includes(value.toLowerCase());
      },
    },
  ];

  return (
    <Page title="Nedané souhlasy s natáčením videí">
      <div>
        <span className="border border-r text-red-300">
          Zde jsou zobrazeni všichni účastníci, kteří nedali souhlas s natáčením videí. Pokud je souhlas již dán,
          účastník se v tomto seznamu nezobrazí.
        </span>
      </div>
      <Table
        columns={columns}
        fetching={loading}
        records={noVideoList}
        id="flash"
        sortFunction={sortNovideo}
        filterConfig={filterConfig}
      />
    </Page>
  );
}
